"use strict";
exports.__esModule = true;
var inflectors = require("en-inflectors");
var Inflectors = inflectors.Inflectors;
var lexicon_1 = require("./lexicon");
exports.lexicon = lexicon_1["default"];
var extend = function (terms) {
    if (typeof terms !== "object" || terms === null) {
        console.warn("You must pass an object to extend the lexicon");
        return;
    }
    for (var term in terms) {
        if (!terms.hasOwnProperty(term))
            continue;
        if (!terms[term])
            continue;
        if (~terms[term].split("|").indexOf("VB") || ~terms[term].split("|").indexOf("VBP")) {
            var VBZ = new Inflectors(term).conjugate("VBZ");
            var VBD = new Inflectors(term).conjugate("VBD");
            var VBN = new Inflectors(term).conjugate("VBN");
            var VBG = new Inflectors(term).conjugate("VBG");
            if (!terms[VBZ])
                terms[VBZ] = "VBZ";
            else
                terms[VBZ] = terms[VBZ] + "|" + "VBZ";
            if (!terms[VBD])
                terms[VBD] = "VBD";
            else
                terms[VBD] = terms[VBD] + "|" + "VBD";
            if (!terms[VBN])
                terms[VBN] = "VBN";
            else
                terms[VBN] = terms[VBN] + "|" + "VBN";
            if (!terms[VBG])
                terms[VBG] = "VBG";
            else
                terms[VBG] = terms[VBG] + "|" + "VBG";
        }
    }
    for (var newEntry in terms) {
        lexicon_1["default"][newEntry] = terms[newEntry];
    }
};
exports.extend = extend;
